import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TextField from "@material-ui/core/TextField";
import { Calendar } from "primereact/calendar";
import { alertActions, FeedbackRptActions } from "../../actions";
import { connect } from "react-redux";
import tableRequest from "../../models/tableRequest.js";
import { Toast } from "primereact/toast";
import { CSVLink } from "react-csv";
import Loader from "../../templates/Loader.js";
import { Dialog } from "primereact/dialog";



class DealerAvStockReport extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.tblResponse.SortColumn = "FeedbackUpdatedOn";
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);

    this.state = {
      loading: false,
      FromDate: new Date(),
      ToDate: new Date(),
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      visible: false,
      sortOrder: "",
      datalist: [],
      audio: "",
      showPopup: false,
      selectedDealer: null,
    };
  }

  componentDidMount() {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7);
    this.tblResponse.FromDate = date.toLocaleDateString();
    this.tblResponse.ToDate = new Date().toLocaleDateString();
    this.setState({
      FromDate: date,
      ToDate: new Date(),
    });
    this.props.fetchApi(this.tblResponse);
    this.props.exportingData(this.tblResponse);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.FeedbackList !== this.props.FeedbackList) {
      if (this.props.FeedbackList) {
        var e = this.props.FeedbackList;
        this.setState({
          totalRecords: e[0]?.TotalRows ?? 0,
        });
      }
    }
  }

  DealerNameTemplate = (rowData) => {
    return (
      <span
        style={{
          color: "blue",
          cursor: "pointer",
          textDecoration: "underline",
          fontWeight: "bold",
        }}
        onClick={() => this.openPopup(rowData)}
      >
        {rowData.UserName}
      </span>
    );
  };

  openPopup(row) {
    this.setState({ showPopup: true, selectedDealer: row });
  }

  closePopup() {
    this.setState({ showPopup: false, selectedDealer: null });
  }

  FilterData = () => {
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
    this.props.exportingData(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  };

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
  }
  getExportData = () => {
  if (!this.props.List || this.props.List.length === 0) return [];

  return this.props.List.map(row => ({
    DealerId: row.DealerId,
    DealerName: row.UserName,
    ProductName: row.ProductName,
    GroupName: row.CategoryName,
    InvoiceNo: row.InvoiceNo,
    TotalQty: row.TotalQty,
    UsedQty: row.TotalUseQty,
    AvailableQty: row.AvailableQty,
    TotalPoints: row.TotalPoints,
    UsedPoints: row.TotalUsedPoint,
    RemainingPoints: row.RemainingPoints,
    LastScanDate: row.LastUsedDate
      ? new Date(row.LastUsedDate).toLocaleDateString("en-GB")
      : ""
  }));
};

  onPage(event) {
    this.props.loadingData(true);
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
      this.props.exportingData(this.tblResponse);
    }, 250);
  }

  searchFilter = (e) => {
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
    this.props.exportingData(this.tblResponse);
  };

  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDt"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.props.fetchApi(this.tblResponse);
    this.props.exportingData(this.tblResponse);
  }

  render() {
   

    return (
      <div className="datatable-filter-demo">
         <style>{`
     .dealer-grid {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 6px;
    row-gap: 6px;
    font-size: 16px;
    align-items: center;
     padding-left: 50px;
  }

  .dealer-grid .label {
    font-weight: 600;
    color: #555;
    white-space: nowrap;
  }

  .dealer-grid .value {
    color: #222;
    word-break: break-word;
  }

  .dealer-grid .highlight {
    color: #1976d2;
    font-weight: 600;
  }

  .dealer-grid .used {
    color: #d32f2f;
    font-weight: 600;
  }

  .dealer-grid .remaining {
    color: #2e7d32;
    font-weight: 600;
  }

  /* Fix PrimeReact dialog spacing */
  .p-dialog-content {
    padding: 12px 16px !important;
  }
`}</style>
        <Toast ref={(el) => (this.toast = el)} />
        <Loader loader={this.props.loading} />

        <Dialog
  header="Dealer Stock Details"
  visible={this.state.showPopup}
  style={{ width: "32vw" }}
  modal
  onHide={() => this.closePopup()}
>
  {this.state.selectedDealer && (
    <div className="dealer-grid">

      <div className="label">Dealer Name</div>
      <div className="value">{this.state.selectedDealer.UserName}</div>

      <div className="label">Invoice No</div>
      <div className="value">{this.state.selectedDealer.InvoiceNo}</div>

      <div className="label">Product Name</div>
      <div className="value">{this.state.selectedDealer.ProductName}</div>

      <div className="label">Group Name</div>
      <div className="value">{this.state.selectedDealer.CategoryName}</div>

      <div className="label">Total Qty</div>
      <div className="value">{this.state.selectedDealer.TotalQty}</div>

      <div className="label">Total Points</div>
      <div className="value highlight">{this.state.selectedDealer.TotalPoints}</div>

      <div className="label">Used Qty</div>
      <div className="value">{this.state.selectedDealer.TotalUseQty}</div>

      <div className="label">Used Points</div>
      <div className="value used">{this.state.selectedDealer.TotalUsedPoint}</div>

      <div className="label">Available Qty</div>
      <div className="value">{this.state.selectedDealer.AvailableQty}</div>

      <div className="label">Remaining Points</div>
      <div className="value remaining">
        {this.state.selectedDealer.RemainingPoints}
      </div>

      <div className="label">Last Scan</div>
      <div className="value">
        {this.state.selectedDealer.LastUsedDate
          ? new Date(this.state.selectedDealer.LastUsedDate).toLocaleDateString("en-US")
          : "-"}
      </div>

    </div>
  )}
</Dialog>


        {/* HEADER */}
        <div className="row mb-3">
          <div className="col-md-3">
            <h4>Dealer Available Stock</h4>
          </div>

          <div className="col-md-9">
            <div className="row text-right">
              <div className="col-md-3">
                <Calendar
                  placeholder="From Date"
                  name="FromDate"
                  showIcon="true"
                  value={this.state.FromDate}
                  onChange={(e) => this.setState({ FromDate: e.value })}
                />
              </div>

              <div className="col-md-3">
                <Calendar
                  placeholder="To Date"
                  name="ToDate"
                  showIcon="true"
                  value={this.state.ToDate}
                  onChange={(e) => this.setState({ ToDate: e.value })}
                />
              </div>

              <div className="col-md-3 text-center">
                <button
                  type="button"
                  onClick={this.FilterData}
                  className="btn btn-primary p-2 ml-3 buttone"
                >
                  Submit
                </button>
                &nbsp;
                <CSVLink
  data={this.getExportData()}
  filename="Dealer Available Stock.csv"
>
  <button className="btn btn-success p-2 mr-2 buttone">
    Export
  </button>
</CSVLink>

              </div>
              <div className="col-md-3">
                <TextField
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Search"
                  onInput={this.searchFilter}
                />
              </div>
            </div>
          </div>
        </div>
        {/* TABLE */}
        <div className="card">
          <DataTable
            value={this.props.FeedbackList}
            scrollable
            responsive
            globalFilter={this.state.globalFilter}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[
              5,
              10,
              100,
              200,
              parseInt(this.state.totalRecords),
            ]}
            totalRecords={this.state.totalRecords}
            lazy
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
          > 
            <Column
              field="UserName"
              header="Dealer Name"
              sortable
              body={this.DealerNameTemplate}
            />
            <Column field="CategoryName" header=" Group Name" sortable/>
            <Column field="TotalQty" header="Total Qty" sortable />
            <Column field="TotalUseQty" header="Total Use Qty" sortable />
            <Column field="AvailableQty" header="Available Qty" sortable />
          </DataTable>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  console.log("state", state);
  return {
    FeedbackList: state.FeedbackRpt.items,
    List:
      state.FeedbackRpt.exportitems === undefined
        ? []
        : state.FeedbackRpt.exportitems,
    loading: state.FeedbackRpt.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(FeedbackRptActions.DealerAvStockReport(obj));
    },
    loadingData: (isLoding) =>
      dispatch(FeedbackRptActions.loadingData(isLoding)),
    exportingData: (obj) =>
      dispatch(FeedbackRptActions.exportDealerAvStockReport(obj)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DealerAvStockReport);